import { usePublicDeliveryApi } from "../../../common/api/delivery-api/usePublicDeliveryApi";

export const usePublicDeliveryBucketsApi = () => {
    const { generateAccessKey, getDeliveryBucketInfo } = usePublicDeliveryApi();

    return {
        generateAccessKey,
        getDeliveryBucketInfo
    };
};
